import React, { useState } from "react";
import styles from "./Card.module.scss";
import NewModal from "../../shared/newModal/NewModal";
import editBtn from "../../../assets/images/otp/Frame 2087326387 (1).svg";
import deleteBtn from "../../../assets/images/otp/delete-2-svgrepo-com.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { setUserName } from "../../../redux/Slices/referalMainAcc";
import { formatDate } from "../../../extentions/date";
import IzlemeImg from "../../../assets/images/user-admin-panel/Card/CodeBlock (1).svg";
import WeightImg from "../../../assets/images/user-admin-panel/Card/eye.svg";
import paymentImg from "../../../assets/images/user-admin-panel/Card/Vector (5).svg";
import DateImg from "../../../assets/images/user-admin-panel/Card/CalendarDots.svg";
import InvoicePrice from "../../../assets/images/user-admin-panel/Card/InvoicePrice.svg";
import StatusIcon from "../../../assets/images/user-admin-panel/Card/StatusIcon.svg";
import WalletImg from "../../../assets/images/user-admin-panel/Card/HandCoins.svg";
import statusImg from "../../../assets/images/user-admin-panel/Card/Truck.svg";
import UserImg from "../../../assets/images/user-admin-panel/Card/Country Icon.svg";
import CopyImg from "../../../assets/images/user-admin-panel/Card/Tracking Code Icon.svg";
import InvoiceImg from "../../../assets/images/user-admin-panel/Card/Invoice Icon.svg";
import DateIcon from "../../../assets/images/user-admin-panel/Card/CalendarDots.svg";
import Country from "../../../assets/images/user-admin-panel/Card/Country.svg";
import EyeImg from "../../../assets/images/courier/Eye (1).svg";
import DetailModal from "../../shared/detailModal/DetailModal";
import { CourierServices } from "../../../services/courier.service";
import { useSite } from "../../../context/TranslationContext";
import { WoltService } from "../../../services/wolt.service";

interface OrderRowProps {
  id?: number;
  full_name?: string;
  address?: string;
  date?: string;
  payment_type?: string;
  delivery_amount?: string;
  total_amount?: string;
  status?: string;
  azerpost_track?: string;
  otp?: string;
  message?: string;
  otp_code?: string;
  otp_text?: string;
  onEdit?: () => void;
  surname?: string;
  name?: string;
  balance?: string;
  referal?: boolean;
  promoCode?: boolean;
  code?: string;
  used_at?: string;
  attornary?: boolean;
  patronymic?: string;
  passport_series?: string;
  passport_number?: string;
  phone_prefix?: string;
  passport_fin?: string;
  birthday?: string;
  phone?: string;
  onDelete?: () => void;
  watchPackages?: boolean;
  original_track?: string;
  last_status_date?: string;
  displayed_weight?: string;
  delivery_original_amount?: string;
  package_delivery_amount_icon?: string;
  onRefresh?: () => void;
  setLoading?: (value: boolean) => void;
  trendyol?: boolean;
  subject?: string;
  created_at?: string;
  expired_at?: string;
  Courier?: boolean;
  isWolt?: boolean;
  Azerpost?: boolean;
  YpOrder?: boolean;
  order_weight?: string;
  amazon?: boolean;
  updated_at?: string;
  RefList?: boolean;
  SelectedPackages?: boolean;
  external_w_debt?: string | null;
  internal_w_debt?: string | null;
  amount?: string;
  track?: string;
  AllReferals?: boolean;
  internal_track?: string;
  country?: string;
  country_name?: string;
  seller?: string;
  flight?: string | null;
  unit?: string;
  category_name?: string;
  invoice_price_icon?: string;
  invoice_price?: string;
  paid_status?: number;
  invoice_doc?: string | null;

  branchName?: string;
  phone1?: string;
  payment_status?: number;
  status_name?: string | null;
  order_date?: string | null;
  work_hours?: string | null;
  expired_date?: string;
}

const Card: React.FC<OrderRowProps> = ({
  address,
  date,
  payment_type,
  delivery_amount,
  phone_prefix,
  total_amount,
  status,
  id,
  azerpost_track,
  otp,
  message,
  otp_code,
  otp_text,
  isWolt,
  onEdit,
  surname,
  name,
  referal,
  promoCode,
  code,
  used_at,
  attornary,
  patronymic,
  passport_series,
  passport_number,
  passport_fin,
  birthday,
  phone,
  onDelete,
  original_track,
  watchPackages,
  last_status_date,
  internal_track,
  displayed_weight,
  delivery_original_amount,
  package_delivery_amount_icon,
  onRefresh,
  setLoading,
  trendyol,
  full_name,
  subject,
  created_at,
  expired_at,
  Courier,
  Azerpost,
  YpOrder,
  order_weight,
  amazon,
  updated_at,
  RefList,
  SelectedPackages,
  track,
  external_w_debt,
  internal_w_debt,
  amount,
  AllReferals,
  country,
  flight,
  country_name,
  seller,
  unit,
  invoice_price,
  invoice_price_icon,
  invoice_doc,
  paid_status,
  branchName,
  phone1,
  status_name,
  order_date,
  work_hours,
  expired_date,
}) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<OrderRowProps | null>(
    null,
  );
  const { data } = useSelector((state: RootState) => state.translationData);
  const [loadingDetail, setLoadingDetail] = useState(false);

  const [detailData, setDetailData] = useState<any>(null);
  const handleShowDetailModal = async (orderId: number) => {
    if (!orderId) return;
    setLoadingDetail(true);
    const { data, status } = await CourierServices.getCourierDetail(orderId);
    setLoadingDetail(false);

    if (status === 200) {
      setDetailData(data.original.packages);
      setShowDetailModal(true);
    } else {
    }
  };

  const handleWoltShowDetailModal = async (orderId: number) => {
    setLoadingDetail(true);
    const { data, status } = await WoltService.getWoltOrderDetails(orderId);
    setLoadingDetail(false);
    if (status === 200) {
      setDetailData(data.packages);
      setShowDetailModal(true);
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div className={styles.cards}>
        {isWolt && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={UserImg} alt="name" />
                </div>
                <div>
                  <p>{data?.auth_referal_full_name}</p>
                  <strong>{full_name}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Çəki" />
                </div>
                <div>
                  <p>{data?.auth_courier_date}</p>
                  <strong>{order_date}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={paymentImg} alt="Ödəniş növü" />
                </div>
                <div>
                  <p>{data?.auth_courier_total_amount}</p>
                  <strong>{total_amount} AZN</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="Tarix" />
                </div>
                <div>
                  <p>{data?.phone}</p>
                  <strong>{phone}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div style={{ width: "40px" }} className={styles.iconWrapper}>
                  <img src={statusImg} alt={data?.status} />
                </div>
                <div>
                  <p>{data?.status}</p>
                  <strong className={styles.status}>{status}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div>
                  <p></p>
                  <strong>
                    <img
                      src={EyeImg}
                      alt=""
                      onClick={() => handleWoltShowDetailModal(id!)}
                      style={{ cursor: "pointer" }}
                    />
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* courier */}
      <div className={styles.cards}>
        {Courier && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="İzləmə kodu" />
                </div>
                <div>
                  <p>{data?.auth_courier_foreign_delivery}</p>
                  <strong>{delivery_amount} azn</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Çəki" />
                </div>
                <div>
                  <p>{data?.auth_courier_service}</p>
                  <strong>{amount}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={paymentImg} alt="Ödəniş növü" />
                </div>
                <div>
                  <p>{data?.auth_courier_total_amount}</p>
                  <strong>{total_amount}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="Tarix" />
                </div>
                <div>
                  <p>{data?.auth_courier_date}</p>
                  <strong>{date}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div>
                  <p>{data?.auth_courier_payment_type}</p>
                  <strong>{payment_type}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div style={{ width: "40px" }} className={styles.iconWrapper}>
                  <img src={statusImg} alt={data?.status} />
                </div>
                <div>
                  <p>{data?.status}</p>
                  <strong className={styles.status}>{status}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div>
                  <p></p>
                  <strong>
                    <img
                      src={EyeImg}
                      alt=""
                      onClick={() => handleShowDetailModal(id!)}
                      style={{ cursor: "pointer" }}
                    />
                  </strong>
                </div>
              </div>
              {/* <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div></div>
              </div> */}
            </div>
          </div>
        )}
      </div>

      {/* Azerpost */}

      <div className={styles.cards}>
        {Azerpost && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="İzləmə kodu" />
                </div>
                <div>
                  <p>{data?.auth_common_tracking_number}</p>
                  <strong>{azerpost_track}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Çəki" />
                </div>
                <div>
                  <p>{data?.weight}</p>
                  <strong>{order_weight}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={paymentImg} alt="Ödəniş növü" />
                </div>
                <div>
                  <p>{data?.auth_courier_payment_type}</p>
                  <strong>{payment_type}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="Tarix" />
                </div>
                <div>
                  <p>{data?.auth_azerpost_date}</p>
                  <strong>{date}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div>
                  <p>{data?.auth_azerpost_delivery_address}</p>
                  <strong>{delivery_amount} azn</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt={data?.status} />
                </div>
                <div>
                  <p>{data?.auth_amount}</p>
                  <strong>{amount}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="ihh" />
                </div>
                <div>
                  <p>{data?.auth_courier_total_amount}</p>
                  <strong>{total_amount}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt={data?.status} />
                </div>
                <div>
                  <p>{data?.status}</p>
                  <strong className={styles.status}>{status}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="ihh" />
                </div>
                <div>
                  <p></p>
                  <strong>
                    <img
                      src={EyeImg}
                      alt=""
                      onClick={() => handleShowDetailModal(id!)}
                      style={{ cursor: "pointer" }}
                    />
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* referal */}
      <div className={styles.cards}>
        {referal && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={UserImg} alt="name" />
                </div>
                <div>
                  <p>{data?.auth_referal_full_name}</p>
                  <strong>{[name, surname].filter(Boolean).join(" ")}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={CopyImg} alt="code" />
                </div>
                <div>
                  <p>{data?.auth_referal_customer_code}</p>
                  <strong>{id}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <button
                  className={styles.accountBtn}
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  {data?.auth_referal_login}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* amazon otp */}

      {/*  */}
      <div className={styles.cards}>
        {amazon && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>{data?.auth_amazon_otp_short}</p>
                  <strong>{otp_code}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.message}</p>
                  <strong>{otp_text}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>{data?.country}</p>
                  <strong>{country}</strong>
                </div>
              </div>
              <div className={styles.edit_btncontainer}>
                <button onClick={onEdit}>{data?.auth_table_header_edit}</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* promocode */}

      <div className={styles.cards}>
        {promoCode && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>{data?.auth_promocode_title} </p>
                  <strong>{code}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={Country} alt="country" />
                </div>
                <div>
                  <p>{data?.country}</p>
                  <strong>{country_name || "-"}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.auth_common_usage_date}</p>
                  <strong>{used_at || "-"}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="expired" />
                </div>
                <div>
                  <p>{data?.expired_date || "Son istifadə tarixi"}</p>
                  <strong>{expired_date ? formatDate(expired_date) : "-"}</strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Attorney */}

      <div className={styles.cards}>
        {attornary && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="Name" />
                </div>
                <div>
                  <p> {data?.auth_attorney_name}</p>
                  <strong>{name}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Çəki" />
                </div>
                <div>
                  <p>{data?.auth_attorney_surname}</p>
                  <strong>{surname}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={paymentImg} alt="Ata adi" />
                </div>
                <div>
                  <p>{data?.auth_attorney_father_name}</p>
                  <strong>{patronymic}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="series" />
                </div>
                <div>
                  <p>{data?.auth_referal_passport_series}</p>
                  <strong>{passport_series}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="passport number" />
                </div>
                <div>
                  <p>{data?.auth_referal_passport_number}</p>
                  <strong>{passport_number} </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt="fin" />
                </div>
                <div>
                  <p>{data?.auth_referal_passport_fin}</p>
                  <strong>{passport_fin}</strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="birthday" />
                </div>
                <div>
                  <p>{data?.auth_referal_birth_date}</p>
                  <strong>{birthday} </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt="phone" />
                </div>
                <div>
                  <p>{data?.auth_referal_phone_number}</p>
                  <strong>
                    {phone_prefix}
                    {phone}
                  </strong>
                </div>
              </div>
            </div>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="delete" />
                </div>
                <div>
                  <p>{data?.auth_common_delete}</p>
                  <strong>
                    {" "}
                    <img
                      style={{ width: "24px", height: "24px" }}
                      src={deleteBtn}
                      alt=""
                      onClick={onDelete}
                    />{" "}
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt="edit" />
                </div>
                <div>
                  <p>{data?.auth_table_header_edit}</p>
                  <strong>
                    {" "}
                    <img src={editBtn} alt="" onClick={onEdit} />
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* trendyol */}

      <div className={styles.cards}>
        {trendyol && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>{data?.trendyol_code}</p>
                  <strong>{code}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.trendyol_subject}</p>
                  <strong>{subject}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.trendyol_created_at}</p>
                  <strong>{created_at ? formatDate(created_at) : "-"}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>{data?.trendyol_expired_at}</p>
                  <strong>{expired_at ? formatDate(expired_at) : "-"}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="Message" />
                </div>
                <div>
                  <p>{data?.trendyol_message}</p>
                  <strong>{message}</strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ReferalList */}

      <div className={styles.cards}>
        {RefList && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="name" />
                </div>
                <div>
                  <p>Taking number</p>
                  <strong>{original_track}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.auth_courier_date}</p>
                  <strong>
                    {last_status_date ? formatDate(last_status_date) : "-"}
                  </strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="Message" />
                </div>
                <div>
                  <p>{data?.weight}</p>
                  <strong>{displayed_weight}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="code" />
                </div>
                <div>
                  <p>{data?.auth_common_shipping_price}</p>
                  <strong>{delivery_original_amount}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={InvoiceImg} alt="invoice" />
                </div>
                <div>
                  <p>{data?.invoice}</p>
                  <strong>
                    <span style={{
                      display: "inline-block",
                      padding: "7px 16px",
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: 600,
                      userSelect: "text",
                      cursor: "default",
                      whiteSpace: "nowrap",
                      background: invoice_doc ? "#6b9e8a" : "#e8000d",
                      color: "#fff",
                    }}>
                      {invoice_doc ? data?.invoice_uploaded : data?.invoice_not_uploaded}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* selectedPackages */}

      <div className={styles.cards}>
        {SelectedPackages && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="İzləmə kodu" />
                </div>
                <div>
                  <p>{data?.auth_common_tracking_code}</p>
                  <strong>{track}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Çəki" />
                </div>
                <div>
                  <p>{data?.auth_amount}</p>
                  <strong>{amount}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Daşınma məbləği" />
                </div>
                <div>
                  <p>{data?.auth_common_foreign_debt}</p>
                  <strong>{external_w_debt} azn</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt="Status" />
                </div>
                <div>
                  <p>{data?.auth_common_local_debt}</p>
                  <strong>{internal_w_debt} azn</strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Alll referals */}

      <div className={styles.cards}>
        {AllReferals && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={UserImg} alt="user" />
                </div>
                <div>
                  <p>{data?.customer}</p>
                  <strong>{full_name}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="track kod" />
                </div>
                <div>
                  <p>{data?.auth_common_tracking_code}</p>
                  <strong>{internal_track}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={Country} alt="reys" />
                </div>
                <div>
                  <p>{data?.flight}</p>
                  <strong>{flight || "-"} </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={Country} alt="olke" />
                </div>
                <div>
                  <p>{data?.country}</p>
                  <strong>{country_name} </strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="weight" />
                </div>
                <div>
                  <p>{data?.weight}</p>
                  <strong>
                    {displayed_weight} {unit}
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="seller" />
                </div>
                <div>
                  <p>{data?.store}</p>
                  <strong>{seller}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={InvoiceImg} alt="invoice doc" />
                </div>
                <div>
                  <p>{data?.invoice}</p>
                  <strong>
                    <span style={{
                      display: "inline-block",
                      padding: "7px 16px",
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: 600,
                      userSelect: "text",
                      cursor: "default",
                      whiteSpace: "nowrap",
                      background: invoice_doc ? "#6b9e8a" : "#e8000d",
                      color: "#fff",
                    }}>
                      {invoice_doc ? data?.invoice_uploaded : data?.invoice_not_uploaded}
                    </span>
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={InvoicePrice} alt="price status" />
                </div>
                <div>
                  <p>{data?.auth_courier_payment_type}</p>
                  <strong>
                    {paid_status === 1 ? data?.paid : data?.unpaid}{" "}
                  </strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={InvoicePrice} alt="invoice price" />
                </div>
                <div>
                  <p>{data?.auth_common_invoice_price}</p>
                  <strong>
                    {invoice_price} {invoice_price_icon}
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={InvoicePrice} alt="payment delivery" />
                </div>
                <div>
                  <p>{data?.auth_common_shipping_price}</p>
                  <strong>
                    {delivery_original_amount} {package_delivery_amount_icon}
                  </strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateIcon} alt="Date" />
                </div>
                <div>
                  <p>{data?.auth_courier_date}</p>
                  <strong>
                    {" "}
                    {last_status_date ? formatDate(last_status_date) : "-"}
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div style={{ width: "40px" }} className={styles.iconWrapper}>
                  <img src={StatusIcon} alt="Status" />
                </div>
                <div>
                  <p>{data?.auth_common_order_status}</p>
                  <strong className={styles.status}>{status}</strong>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* YP Order */}
      <div className={styles.cards}>
        {YpOrder && (
          <div className={styles.card}>
            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={IzlemeImg} alt="ID" />
                </div>
                <div>
                  <p>ID</p>
                  <strong>{id || "-"}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WeightImg} alt="Filial" />
                </div>
                <div>
                  <p>{data?.yp_branches || "Filial"}</p>
                  <strong>{branchName || "-"}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={paymentImg} alt="Ünvan" />
                </div>
                <div>
                  <p>{data?.address || "Ünvan"}</p>
                  <strong style={{ fontSize: "9px !important" }}>
                    {address || "-"}
                  </strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="Telefon" />
                </div>
                <div>
                  <p>{data?.phone || "Telefon"}</p>
                  <strong>{phone1 || "-"}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="İş saatları" />
                </div>
                <div>
                  <p>{data?.working_hours_yp}</p>
                  <strong>{work_hours}</strong>
                </div>
              </div>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={DateImg} alt="Tarix" />
                </div>
                <div>
                  <p>{data?.auth_azerpost_date}</p>
                  <strong>{order_date}</strong>
                </div>
              </div>
            </div>

            <div className={styles.cardRow}>
              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={WalletImg} alt="Məbləğ" />
                </div>
                <div>
                  <p>{data?.auth_azerpost_total_amount || "Məbləğ"}</p>
                  <strong>{amount ? `${amount} AZN` : "-"}</strong>
                </div>
              </div>

              <div className={styles.cardItem}>
                <div className={styles.iconWrapper}>
                  <img src={statusImg} alt="Status" />
                </div>
                <div>
                  <p>{data?.status || "Status"}</p>
                  <strong className={styles.status}>{status_name}</strong>
                </div>
              </div>
            </div>

            {order_weight && (
              <div className={styles.cardRow}>
                <div className={styles.cardItem}>
                  <div className={styles.iconWrapper}>
                    <img src={WeightImg} alt="Çəki" />
                  </div>
                  <div>
                    <p>{data?.weight || "Çəki"}</p>
                    <strong>{order_weight}</strong>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {showDetailModal && detailData && (
        <DetailModal
          title=""
          content="Bağlama Detalları"
          onClose={() => setShowDetailModal(false)}
          musteriId={id}
          orderData={detailData}
          setShowModal={setShowDetailModal}
        />
      )}

      {showModal && (
        <NewModal
          title=""
          content={data?.switch_account_confirm}
          onClose={() => setShowModal(false)}
          confirmText={data?.auth_logout_yes}
          cancelText={data?.auth_logout_no}
          musteriId={id}
          setShowModal={setShowModal}
          setLoading={setLoading ?? (() => {})}
        />
      )}
    </div>
  );
};

export default Card;
